import $ from 'jquery';

App.registerBehavior('LoginRemoteToggle', function () {
  // User login
  $('[data-action="open-login"]').once('LoginUserRemoteToggleBehavior').each(function () {
    $(this).on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const $object = $('.login-bar__user');
      // trigger click event on button
      openBurgerMenuFirst();
      $('.login-bar__user > .login-bar__button').trigger('click');
      scrollToAndFocusInput($object);
    });
  });
  // TAN login
  $('[data-action="open-tan"]').once('LoginTanRemoteToggleBehavior').each(function () {
    $(this).on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const $object = $('.login-bar__participant');
      // trigger click event on button
      openBurgerMenuFirst();
      $('.login-bar__participant > .login-bar__button').trigger('click');
      scrollToAndFocusInput($object);
    });
  });
  // Helper
  function openBurgerMenuFirst() {
    const burgerMenuIconButton = $('.site-header__nav-toggle');
    if (!burgerMenuIconButton.is(':hidden')) {
      $('.site-header__nav-toggle').trigger('click');
    }
  }
  function scrollToAndFocusInput(object) {
    // get offset for object
    const objectOffset = (typeof object[0] !== 'undefined' && object.length) ? object.offset().top : null;
    if (objectOffset) {
      $('html, body').animate({
        scrollTop: objectOffset,
      }, 600);
      const input = object.find('input[type="text"]');
      if (input) {
        input.trigger('focus');
      }
    }
  }
});